import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  LineHeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const widgetHeaderClassName = css({
  alignItems: 'center',
  display: 'flex',
  marginBottom: Spacing.MD,
  [SMALL_DEVICE_MQ]: {
    borderBottom: `1px solid ${Colors.LightGray}`,
    paddingBottom: Spacing.MD,
  },
});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.BOLD,
  lineHeight: LineHeight.LARGE,
  marginRight: 'auto',
  [SMALL_DEVICE_MQ]: {
    fontWeight: FontWeight.SEMI_BOLD,
  },
});

export const widgetBodyClassName = css({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.LG,
  [SMALL_DEVICE_MQ]: {
    gap: Spacing.MD,
  },
});

export const widgetStatsClassName = css({
  display: 'grid',
  gap: Spacing.MD,
  gridTemplateColumns: '1fr 1fr',
  marginTop: Spacing.LG,
  [SMALL_DEVICE_MQ]: {
    marginTop: Spacing.MD,
  },
});

export const widgetFooterClassName = css({
  marginTop: Spacing.LG,
});

export const footerLinkWrapperClassName = css({
  marginTop: Spacing['2XS'],
});

export const footerLinkClassName = css({
  alignItems: 'center',
  color: Colors.Brand,
  display: 'flex',
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const linkIconClassName = css({
  color: Colors.Brand,
  height: 14,
  width: 14,
  marginLeft: Spacing.XS,
});
